export default "__VITE_ASSET__D99VUP8x__"